module.exports = __webpack_public_path__ + "img/fashion_23.5fc53de5.jpg";